import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';

export const StyledPaper = styled(Paper)`
    ${({ theme }) => `
    background-color: ${theme.palette.common.white};
    width: 824px;
    max-width: none;
    border-radius: 16px;
    `}
`;

export const StyledDialogContent = styled(DialogContent)`
    ${() => `
    padding: 23px;
    `}
`;

export const StyledDialogActions = styled(DialogActions)`
    ${() => `
    padding: 23px;
    `}
`;

export const StyledDuplicatePaper = styled(Paper)`
    ${({ theme }) => `
        background-color: ${theme.palette.common.white};
        width: 496px;
        max-width: none;
        border-radius: 16px;
        padding: 32px 48px;
        display: flex;
        flex-direction: column;
        row-gap: 15px;
        position: relative;
    `}
`;

export const StyledWorkoutGroupContainer = styled.div`
    ${({ theme }) => `
    display: flex;
    flex-wrap: wrap;
    padding-left: 12px;
    `}
`;

export const StyledWorkoutGroupButton = styled(Button)`
    ${({ theme, $isActive }) => `
        color: ${$isActive ? theme.palette.common.black : theme.palette.common.gray7};
        text-transform: none;
    `}
`;

export const StyledWorkoutContainer = styled.div`
    ${({ theme }) => `
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        margin-top: 10px;
        min-height: 120px;
        align-content: flex-start;
    `}
`;

export const StyledWorkoutButtonContainer = styled.div`
    ${({ theme }) => `
        display: flex;
        align-items: center;
        // border: 1px solid ${theme.palette.common.gray7};
        border-radius: 16px;
        overflow: hidden;
        height: 32px;
    `}
`;

export const StyledWorkoutButtonDividerContainer = styled.div`
    ${({ theme }) => `
        display: flex;
        align-items: center;
        height: 100%;
        border-top: 1px solid ${theme.palette.common.gray7};
        border-bottom: 1px solid ${theme.palette.common.gray7};
    `}
`;

export const StyledWorkoutButtonDivider = styled.div`
    ${({ theme, $isActive }) => `
        width: 1px;
        height: ${$isActive ? '100%' : '80%'};
        background-color: ${theme.palette.common.gray7};
    `}
`;

export const StyledWorkoutButton = styled(Button)`
    ${({ theme, $isActive }) => `
        min-width: unset;
        height: 32px;
        border-radius: 16px 0 0 16px;
        text-transform: none;
        padding: 0 13px;

        font-weight: 400;
        font-size: 16px;
        
        color: ${$isActive ? theme.palette.common.white : theme.palette.common.black};
        background-color: ${$isActive ? theme.palette.common.green10 : theme.palette.common.white};
        border-top: 1px solid ${
            $isActive ? theme.palette.common.green10 : theme.palette.common.gray7
        };
        border-bottom: 1px solid ${
            $isActive ? theme.palette.common.green10 : theme.palette.common.gray7
        };
        border-left: 1px solid ${
            $isActive ? theme.palette.common.green10 : theme.palette.common.gray7
        };

        &:hover {
            color: ${$isActive ? theme.palette.common.white : theme.palette.common.black};
            background-color: ${
                $isActive ? theme.palette.common.green11 : theme.palette.common.white2
            };
        }
        
    `}
`;

export const StyledWorkoutDeleteButton = styled(Button)`
    ${({ theme }) => `
        border-radius: 0 16px 16px 0;
        min-width: unset;
        height: 32px;
        padding: 0 13px;

        border-top: 1px solid ${theme.palette.common.gray7};
        border-bottom: 1px solid ${theme.palette.common.gray7};
        border-right: 1px solid ${theme.palette.common.gray7};


    `}
`;

export const StyledSelectedWorkoutContainer = styled.div`
    ${({ theme, error }) => `
        border-radius: 16px;
        border: 1px solid ${error ? theme.palette.common.red : theme.palette.common.gray7};
        padding: 11px;
        display: flex;
        flex-wrap: wrap;
        column-gap: 12px;
        margin-top: 10px;
        min-height: 120px;
    `}
`;

export const StyledSelectedWorkoutContainerButton = styled.div`
    ${({ theme }) => `
        height: 32px;
        border-radius: 16px;
        background-color: ${theme.palette.common.green10};
        display: flex;
        align-items: center;
        padding: 0 10px 0 15px;
    `}
`;

export const StyledWorkoutInput = styled.div`
    ${({ theme }) => `
        border-radius: 16px;
        height: 32px;
        border: 1px solid ${theme.palette.common.gray7};
        padding: 0 10px 0 15px;
        display: flex;
        align-items: center;
        column-gap: 5px;
    `}
`;

export const StyledSelectContainer = styled.div`
    ${() => `
        display: grid;
        grid-template-columns: repeat(2,272px);
        column-gap: 20px;
    `}
`;

export const StyledShowMoreContainer = styled.div`
    ${({ theme }) => `
        color: ${theme.palette.common.gray2};
        font-size: 14px;
    `}
`;
